<template>
  <div v-bind:class="getClassBot()">
    <div :class="getClassBotAberto()" v-if="isBotOpen">
      <div class="bot_cabecalho">
        <img class="bot_imagem" :src="toDataURL(imagemBot.image, imagemBot.contentType)" />
        <h6>Assistente</h6>
        <div @click="maximizarBot" :class="getClassTamanhoBot()" style="color:#fff"><i :class="getIconWindowBot()"></i>
        </div>
        <div @click="desativarBot" :class="getClassFecharBot()" style="color:#fff"><i :class="getIconCloseBot()"></i>
        </div>
      </div>
      <div id="corpo-chamado" class="bot_corpo_de_mensagem m-2">
        <div class="container">
          <div class="row" v-for="mensagem in mensagens" :key="mensagem.id">
            <BotMensagem :mensagem="mensagem" @resposta="onResposta" @reiniciar="reiniciarBot(true)" @input="onInput">
            </BotMensagem>
          </div>
        </div>
      </div>
      <div class="bot_rodape_enviar_mensagem" style="padding: 14px; background-color: #E8EAEC;">
        <input class="enviar_mensagem_bot" placeholder="Escreva sua mensagem aqui..." v-model.trim="input"
          @keydown.enter="onInput(input)" rows="1" />
        <button class="botao_enviar_mensagem_bot" @click="onInput(input)">
          <i class="fab fa-telegram-plane"></i>
        </button>
      </div>
    </div>
    <div v-if="!isBotOpen">
      <div class="balao_fala_bot" v-if="mostrarBalao">
        <button type="button" class="close-bot" aria-label="Fechar" @click="tirarbalao()">
          <span aria-hidden="true">&times;</span>
        </button>
        <p class="p-4 text-center fala_bot" @click="ativarBot">
          {{ getTextoFromUrl() }}
        </p>
      </div>
      <div id="ativar-bot" @click="ativarBot" ref="bot">
        <img :src="toDataURL(imagemBot.image, imagemBot.contentType)" />
      </div>
    </div>

    <ModalResetarBot idModal="resetar-bot" tituloModal="teste" @reiniciar="reiniciarBot(true)"></ModalResetarBot>
  </div>
</template>

<script>
import ModalResetarBot from "../components/Bot/ModalResetarBot.vue";
import Util from "../util/Util";
import BotMachine from "./BotMachine";
import BotMensagem from "./BotMensagem.vue";

//Retirado do bot antigo
import ClienteAPI from "@/services/config/Cliente";
import ConfigPersonalizadaAPI from "@/services/config/ConfiguracaoPersonalizada";
import { useState } from "@/store/ClienteStore";
import { inject } from "vue";
import { useRouter } from "vue-router";

export default {
  components: {
    ModalResetarBot,
    BotMensagem
  },
  props: {
    standalone: Boolean,
    mode: { type: String, default: "fullscreen" }
  },
  name: "Bot",
  data() {
    return {
      mostrarBalao: true,
      botHabilitado: false,
      imagemBot: {},
      mensagens: [],
      input: '',
      innerMode: '',
    };
  },
  watch: {
    botHabilitado() {
      // this.resetBot()
    },
    rotaAtual(val) {
      const nomeRotaAtual = val.name;
      this.verificaSeMostraBot(val);
      this.verificaSeMostrarBalaoBot(nomeRotaAtual);
    },
  },
  //teste, excluir depois
  setup(props) {

    //Retirado do bot antigo
    let isBotOpen = inject("isBotOpen", false);
    const router = useRouter();
    const rotaAtual = router.currentRoute;
    const clientInfos = useState();
    const { getImagem } = ClienteAPI();
    const { getConfigPersonalizada } = ConfigPersonalizadaAPI();
    const { toDataURL, getClienteFromUrl, mostrarModal, esconderModal } = Util();

    return {
      mostrarModal,
      esconderModal,
      rotaAtual,
      toDataURL,
      getClienteFromUrl,
      getImagem,
      getConfigPersonalizada, clientInfos, isBotOpen
    };
  },
  methods: {
    // Balão conforme o camilho na URL

    async onResposta(resposta) {
      this.mensagens.push({ texto: resposta.texto, isUser: true });
      this.mensagens.push({ tipo: "loader", texto: "..." });
      const res = await BotMachine.onResposta(resposta);
      setTimeout(async () => {
        this.mensagens = this.mensagens.filter(function (obj) {
          return obj.tipo !== "loader";
        })

        this.mensagens = this.mensagens.concat(res);
      }, 1000)
    },

    async onInput(text) {
      if (!text) return;
      let ultimaMensagem = this.mensagens[this.mensagens.length - 1];
      this.mensagens.push({ texto: text, isUser: true });
      this.mensagens.push({ tipo: "loader", texto: "..." })
      this.input = null;
      const res = await BotMachine.onIput(text, ultimaMensagem);
      setTimeout(async () => {
        this.mensagens = this.mensagens.filter(function (obj) {
          return obj.tipo !== "loader";
        })
        if (res === 'RESTART') {
          this.mensagens = this.resetBot();
        }
        this.mensagens = this.mensagens.concat(res);
      }
        , 1000)
    },

    async resetBot() {
      const vm = this;
      BotMachine.inicio().then(m => vm.mensagens = m);
    },

    // Utils
    getTextoFromUrl() {
      const path = window.location.pathname;
      if (path.includes("login")) {
        return "Problemas com login? Fale comigo.";
      } else {
        return "Precisa de ajuda? Abra seu chamado comigo!";
      }
    },

    ativarBot() {
      this.isBotOpen = true;
      this.mostrarBalao = true;
      window.parent.postMessage("abrir-bot", "*");
    },

    desativarBot() {
      this.mostrarBalao = true;
      clearInterval(this.intervalID)
      if (this.innerMode !== "fullscreen") {
        this.isBotOpen = false;
        this.innerMode = "minimize";
        // window.parent.postMessage("fechar-bot", "*");
        this.resetBot();
      } else {
        this.mostrarModal("resetar-bot")
      }
    },
    getClassFecharBot() {
      return this.innerMode === "fullscreen" ? 'icone_reiniciar_bot' : 'icone_diminuir_bot'
    },

    getClassTamanhoBot() {
      return this.innerMode === "maximize" ? 'icone_minimizar_bot' : 'icone_maximizar_bot'
    },

    getClassBot() {
      if (this.innerMode === "fullscreen") {
        this.isBotOpen = true;
      }
      let classes = {
        'maximize': 'bot-maximize',
        'minimize': 'bot',
        'fullscreen': 'bot-fullscreen'
      }
      return classes[this.innerMode];
    },
    getClassBotAberto() {
      let classes = {
        'maximize': 'bot_aberto_maximize',
        'minimize': 'bot_aberto',
        'fullscreen': 'bot_aberto_fullscreen'
      }
      return classes[this.innerMode];
    },

    getIconWindowBot() {
      var icons = {
        'minimize': 'far fa-window-maximize fa-sm',
        'maximize': 'far fa-window-minimize '
      }
      return icons[this.innerMode];
    },

    getIconCloseBot() {
      return this.innerMode === "fullscreen"
        ? 'fas fa-redo' : 'fas fa-times';
    },

    maximizarBot() {
      var actions = {
        'minimize': 'maximize',
        'maximize': 'minimize'
      }
      this.innerMode = actions[this.innerMode];
    },
    tirarbalao() {
      this.mostrarBalao = false;
    },
    verificarMostrarBalaoDeFalaEBot() {
      const path = window.location.pathname;
      // if (
      //   (!this.clientInfos.infos.usarSms && path.includes("login")) ||
      //   path.includes("admin")
      // ) {
      //   this.mostrarBalao = false;
      //   this.botHabilitado = false;
      // } else if (path === "/" || path.includes("auth")) {
      //   this.mostrarBalao = false;
      //   this.botHabilitado = false;
      // } else {
      //   this.botHabilitado = true;
      //   this.mostrarBalao = false;
      // }
      this.botHabilitado = false;
      this.mostrarBalao = true;
    },
    verificaSeMostraBot(rotaAtual) {
      if (
        rotaAtual.path.includes("/admin") ||
        rotaAtual.path.includes("/servico-indisponivel")
      ) {
        this.botHabilitado = false;
      } else if (
        rotaAtual.path.includes("/login") &&
        !this.clientInfos.infos.usarSms
      ) {
        this.botHabilitado = false;
      } else if (rotaAtual.path.includes("/auth") || rotaAtual.name == "Home") {
        this.reiniciarBot(true);
      } else this.botHabilitado = true;
    },
    verificaSeMostrarBalaoBot(nomeRotaAtual) {
      if (nomeRotaAtual !== "Home" && nomeRotaAtual !== "Login") {
        this.mostrarBalao = false;
      } else {
        this.mostrarBalao = true;
      }
    },
    setaImagemBot({ data }) {
      this.imagemBot = data;
    },

    reiniciarBot(reset) {
      this.esconderModal("resetar-bot");
      if (reset) {
        this.resetBot();
      }
    }

  },
  created() {
    BotMachine.resetPersist();
  },
  async mounted() {
    this.getImagem("icone-botao-bot", this.getClienteFromUrl()).then(this.setaImagemBot);
    this.innerMode = this.mode;
    this.mensagens = await BotMachine.inicio();

    this.getConfigPersonalizada().then(res => this.isBotOpen = res.data.botAberto);
    this.verificarMostrarBalaoDeFalaEBot();
    const vm = this;
    let count = 0;
    document.getElementById('ativar-bot').classList.add('flipper'); 
    let intervalID = setInterval(() => {
      console.log('interval')
      if (vm.innerMode == 'minimize' && count++ <= 5) {
        document.getElementById('ativar-bot').classList.remove('flipper')
        console.log('removeu flipper')
        setTimeout(() => {
          document.getElementById('ativar-bot').classList.add('flipper'); 
          console.log('adicionou flipper')
        }, 5)
      } else {
        clearInterval(intervalID);
        console.log('clear interval')
      }
    }, 1000 * 15)
    console.log('intervalID', intervalID)
    vm.intervalID = intervalID;
  }
};
</script>

<style scoped>
.flipper {
  transform: rotateY(360deg);
  transition: 1s;
}
</style>